;(function () {
  /**
   * Equalize min-height of target elements within any container
   * marked with: data-equalize="min-height"
   *
   * Usage:
   * <div data-equalize="min-height" data-equalize-target=".card-title">
   *   <h3 class="card-title">...</h3>
   *   ...
   * </div>
   */
  /**
   * @param {(this: any, ...args: any[]) => void} fn
   * @param {number} [wait]
   */
  function debounce(fn, wait) {
    /** @type {number|undefined} */
    var timeoutId
    return function () {
      var ctx = this
      var args = arguments
      clearTimeout(timeoutId)
      timeoutId = setTimeout(function () {
        fn.apply(ctx, args)
      }, wait || 150)
    }
  }

  /** @param {Element} container */
  function equalizeContainer(container) {
    var mode = container.getAttribute('data-equalize')
    if (mode !== 'min-height') return

    var selector = container.getAttribute('data-equalize-target') || '[data-equalize-item]'
    var cssVar = container.getAttribute('data-equalize-var') || '--equal-heading-min-height'
    /** @type {HTMLElement[]} */
    var nodes = Array.prototype.slice.call(container.querySelectorAll(selector))
    if (!nodes.length) return

    /** @type {HTMLElement} */
    var containerEl = /** @type {HTMLElement} */ (container)

    // Reset CSS variable before measuring
    containerEl.style.setProperty(cssVar, 'auto')

    // Measure tallest
    var max = 0
    nodes.forEach(function (/** @type {HTMLElement} */ node) {
      var h = node.getBoundingClientRect().height
      if (h > max) max = h
    })

    // Apply via CSS variable
    if (max > 0) {
      var px = String(Math.ceil(max)) + 'px'
      containerEl.style.setProperty(cssVar, px)
      container.setAttribute('data-equalize-applied', px)
    } else {
      containerEl.style.setProperty(cssVar, 'auto')
      container.removeAttribute('data-equalize-applied')
    }
  }

  function runAll() {
    var containers = document.querySelectorAll('[data-equalize="min-height"]')
    Array.prototype.forEach.call(containers, equalizeContainer)
  }

  var run = function () {
    runAll()
  }

  // Initial and responsive updates
  document.addEventListener('DOMContentLoaded', run)
  window.addEventListener('load', run)
  window.addEventListener('resize', debounce(run, 150))

  // Ensure it runs even if loaded after events
  run()
})()

// // Handle hash navigation from other pages
// ;(function() {
//   function scrollToHash() {
//     var hash = window.location.hash;
//     if (!hash) return;

//     // Remove the # to get the element ID
//     var targetId = hash.substring(1);
//     var targetElement = document.getElementById(targetId);
    
//     if (targetElement) {
//       var el = targetElement;
//       // Small delay to ensure page is fully rendered
//       setTimeout(function() {
//         el.scrollIntoView({ 
//           behavior: 'smooth',
//           block: 'start'
//         });
//       }, 100);
//     }
//   }

//   // Handle hash on page load (when navigating from another page)
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', scrollToHash);
//   } else {
//     scrollToHash();
//   }

//   // Also handle when user clicks hash links on the same page
//   document.addEventListener('click', function(e) {
//     var clickTarget = e.target;
//     if (!(clickTarget instanceof Element)) return;
//     var target = clickTarget.closest('a[href^="#"]');
//     if (!target) return;

//     var hash = target.getAttribute('href');
//     if (!hash || hash === '#') return;

//     var targetId = hash.substring(1);
//     var targetElement = document.getElementById(targetId);
    
//     if (targetElement) {
//       var el = targetElement;
//       e.preventDefault();
//       el.scrollIntoView({ 
//         behavior: 'smooth',
//         block: 'start'
//       });
      
//       // Update URL without triggering page reload
//       if (history.pushState) {
//         history.pushState('', '', hash);
//       } else {
//         window.location.hash = hash;
//       }
//     }
//   });

//   // Handle browser back/forward with hash changes
//   window.addEventListener('hashchange', scrollToHash);
// })();

